import { render, staticRenderFns } from "./SharedDatabasePage.vue?vue&type=template&id=d6e53984&scoped=true"
import script from "./SharedDatabasePage.vue?vue&type=script&lang=js"
export * from "./SharedDatabasePage.vue?vue&type=script&lang=js"
import style0 from "./SharedDatabasePage.vue?vue&type=style&index=0&id=d6e53984&prod&scoped=true&lang=css"
import style1 from "./SharedDatabasePage.vue?vue&type=style&index=1&id=d6e53984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e53984",
  null
  
)

export default component.exports